import { gql } from "@stadium/services/apollo-client";
import { DUMMY_STORE_DETAILS } from "@graphql/fragments/dummy-store-details";

export const createDummyStore = gql`
  mutation CreateDummyStore($input: CreateDummyStoreInput!) {
    createDummyStore(input: $input) {
      dummyStore {
        ...DummyStoreDetails
      }
      errors
    }
  }
  ${DUMMY_STORE_DETAILS}
`;
